import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/main.scss';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import configureStore from './store';
import { PersistGate } from 'redux-persist/integration/react'

const configuredStore = configureStore();

ReactDOM.render(
  <Provider store={configuredStore.store}>
    <PersistGate loading={null} persistor={configuredStore.persistor}>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
